import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

import {
	ContactDialogComponent,
	ContactDialogData,
	ContactDialogResult,
} from "./contact-dialog.component";

/**
 * Apertura centralizada del diálogo integral de Persona (ver/editar/crear).
 * Aplica el overlay unificado (`ds-dialog-panel`/`ds-dialog-backdrop`) y el tamaño
 * grande necesario para la visualización completa.
 *
 * El caller puede suscribirse a `ref.componentInstance.changed` (eventos en vivo) y/o
 * a `ref.afterClosed()` (resultado final) para refrescar su listado.
 */
@Injectable({ providedIn: "root" })
export class ContactDialogService {
	constructor(private readonly dialog: MatDialog) {}

	open(
		data: ContactDialogData,
	): MatDialogRef<ContactDialogComponent, ContactDialogResult> {
		return this.dialog.open<
			ContactDialogComponent,
			ContactDialogData,
			ContactDialogResult
		>(ContactDialogComponent, {
			data,
			panelClass: "ds-dialog-panel",
			backdropClass: "ds-dialog-backdrop",
			width: "1040px",
			maxWidth: "96vw",
			autoFocus: false,
			restoreFocus: true,
		});
	}

	view(contactId: number) {
		return this.open({ mode: "view", contactId });
	}

	edit(contactId: number) {
		return this.open({ mode: "edit", contactId });
	}

	create(entityId: number, entityType: string, entityName?: string) {
		return this.open({ mode: "create", entityId, entityType, entityName });
	}
}
